
import { defineComponent } from 'vue'

export default defineComponent({
  data () {
    return {
      myself: {
        affiliation: `Assistant Professor
        Yusuke Kato group
        Department of Basic Science, The University of Tokyo, Japan`,
        text: `Research interest: Unconventional superconductivity, Topological material science, Multipole moments in solids /
        Methods: Group theory (representation theory), Topology, Numerical calculations (C++, Python, Julia, Mathematica), etc.`,
        imageFile: require('@/assets/top/profile.jpg')
      }
    }
  }
})
